import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f3344d24&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3344d24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3344d24')) {
      api.createRecord('f3344d24', component.options)
    } else {
      api.reload('f3344d24', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f3344d24&scoped=true&", function () {
      api.rerender('f3344d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/comp/Accordion.vue"
export default component.exports